import React, { useState } from 'react';
import { connect } from 'react-redux';
import HalfCardHeader from '../Msite/HalfCardHeader';
import DesktopRatingProductCard from '../../RatingProductCard';
import './FeedBackCard.scss';
import { getFeedBackPendingProducts } from '../../../selectors/ratingSelector';
import { gtmEventPush, segmentEventPush } from '../../../../modules/ga/GTMdatalayer';
import { FeedBackProductCardType, ModalDataType } from '../types';

interface FeedBackCardPropsType {
  updateModal: (modalName: string, {}) => void;
  fetchRatingByUser: ({}) => void;
  feedBackPendingProducts: FeedBackProductCardType[];
  fetchAggRating: boolean;
  fetchSubRatingQuestion: boolean;
  hideModal: () => void;
  sourcePage: string;
  modalData: ModalDataType;
}

const FeedbackCard = (props: FeedBackCardPropsType) => {
  const {
    updateModal,
    fetchRatingByUser,
    feedBackPendingProducts,
    fetchSubRatingQuestion = true,
    fetchAggRating = false,
    hideModal,
    sourcePage,
    modalData
  } = props;
  const { pageName = '', pageType = '', isFromWriteReview = false } = modalData;
  const [errorInRatingAPI, setErrorInAPIRating] = useState('');

  const ratingClickHandler = async ({
    rating,
    brandName,
    description,
    imageUrl,
    skuId,
    orderId = '',
    brickCode = ''
  }: {
    rating: number;
    brandName: string;
    description: string;
    imageUrl: string;
    skuId: string;
    orderId?: string;
    brickCode?: string;
  }) => {
    const responseOfRating = await fetchRatingByUser({
      sourcePage,
      skuData: skuId,
      rating,
      fetchSubRatingQuestion,
      fetchAggRating
    });
    gtmEventPush({
      event: 'reviews_rating_interactions',
      event_category: 'reviews & ratings interactions',
      event_action: 'overall rating',
      event_label: rating,
      ...(orderId.length > 0 && { order_id: orderId }),
      ...(brickCode.length > 0 && { product_brick: brickCode }),
      product_id: skuId,
      product_name: description,
      page_name: pageName,
      page_type: pageType,
      store_type: 'ajio'
    });
    // Segment Push Event
    segmentEventPush({
      event: 'Ratings Collected',
      event_category: 'reviews & ratings interactions',
      event_action: 'overall rating',
      event_label: rating,
      ...(orderId.length > 0 && { order_id: orderId }),
      // ...(brickCode.length > 0 && { product_brick: brickCode }),
      products:[{
        product_id: skuId,
        product_name: description,
      }],    
      rating_value: rating,
      screen_name: pageName,
      // page_type: pageType,
      store_type: 'ajio'
    });


    if (responseOfRating?.statusCode === 200) {
      updateModal('rating-halfcard', {
        state: {
          deviceType: 'desktop',
          rating,
          pageToDisplay: 'ratingHalfCard',
          productDetails: {
            brandName,
            description,
            imageUrl,
            skuId
          },
          displayFeedBackPage: true,
          isfromWriteFeedBack: false,
          isFeedBackSubmitted: true
        }
      });
    } else {
      setErrorInAPIRating(skuId);
    }
  };

  const continueClickHandler = () => {
    hideModal();
  };

  return (
    <div className="rating-feedback-content">
      <HalfCardHeader
        variant="desktop"
        feebackCard
        pendingFeedBacksIsEmpty={feedBackPendingProducts.length === 0}
      />
      <div className="feedback-products-container">
        {feedBackPendingProducts.length > 0 && (
          <>
            <p className="feedback-heading">Pending Feedbacks</p>
            <div className="products-container">
              {feedBackPendingProducts.map((product, index) => {
                return (
                  <div>
                    <div className="product-container">
                      <DesktopRatingProductCard
                        key={product.id}
                        brandName={product.brandName}
                        description={product.brandTitle}
                        productRating={0}
                        imageUrl={product.imageUrl}
                        productCode={product.productCode}
                        variant="desktop"
                        feedbackCard
                        displayError={product.skuId === errorInRatingAPI}
                        onRatingClickHandler={rating => {
                          ratingClickHandler({
                            rating,
                            brandName: product.brandName,
                            description: product.brandTitle,
                            imageUrl: product.imageUrl,
                            skuId: product.skuId
                          });
                        }}
                      />
                    </div>
                    {index + 1 !== feedBackPendingProducts.length && <hr className="line-break" />}
                  </div>
                );
              })}
            </div>
          </>
        )}
        <button className="feedback-rating-card-cta" onClick={continueClickHandler}>
          <p className="rating-card-cta-text">CONTINUE</p>
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    feedBackPendingProducts: getFeedBackPendingProducts(state)
  };
};

export default connect(mapStateToProps)(FeedbackCard);
